import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { MerchantList, TerminalList, TerminalDetail, TerminalEdit } from './components';
import { TerminalActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    }
})

const IdentitySelector = (state) => state.Identity;

const Terminal = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const terminalActions = bindActionCreators(TerminalActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { token, userData } = useSelector(IdentitySelector);

    //const [mode, setMode] = useState('mlist');
    const [modeInfo, setModeInfo] = useState({
        mode: 'mlist', merchant_id: '', merchant_name: '', merchantName: '', merchantType: '', shopName: '', terminalType: '', terminalId: '', machineRwCd: '', merchantOrgInfo: '', isInstalled: ''
    });


    const [listRefresh, setListRefresh] = useState(true);

    const { classes } = props;

    //console.log("role=" + role);

    /**
     *
     * 端末一覧画面表示
     *
     * @param data 選択された行のデータ
     */
    const showTerminalList = (data, merchantName, merchantType) => {
        //setMode('tlist');
        if (data == null || data == undefined) {
            // 編集画面などからも戻るボタンでの遷移時
            setModeInfo({ mode: 'tlist', merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchantName: modeInfo.merchantName, merchantType: modeInfo.merchantType, shopName: modeInfo.shopName, terminalType: modeInfo.terminalType, terminalId: modeInfo.terminalId, machineRwCd: modeInfo.machineRwCd, merchantOrgInfo: modeInfo.merchantOrgInfo, isInstalled: modeInfo.isInstalled })
        }
        else {
            // 加盟店一覧から遷移時
            // storeに選択した加盟店の端末リストを要求
            terminalActions.listTerminals(token, data.id, '')
                .then(res => {
                    // 取得した端末一覧を表示
                    setModeInfo({ mode: 'tlist', merchant_id: data.id, merchant_name: data.merchant_name, merchantName: merchantName, merchantType: merchantType, shopName: '', terminalType: '', terminalId: '', machineRwCd: '', merchantOrgInfo: '', isInstalled: '' })
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });
        }
    }

    /**
　　 *
 　　* 端末詳細画面表示
 　　*
 　　* @param data 選択された行のデータ
 　　*/
    const showDetail = (data, merchantName, merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled) => {
        terminalActions.loadEditModel(token, data.id, data.merchant_id)
            .then(data => {
                //setMode('detail');
                setModeInfo({ mode: 'detail', merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchantName: merchantName, merchantType: merchantType, shopName: shopName, terminalType: terminalType, terminalId: terminalId, machineRwCd: machineRwCd, merchantOrgInfo: merchantOrgInfo, isInstalled: isInstalled })
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 端末リスト画面表示
     *
     * @param data 選択された行のデータ
     */
    const showList = (merchantName, merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled) => {
        setListRefresh(false);
        //setMode('mlist');
        setModeInfo({ mode: 'mlist', merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchantName: merchantName, merchantType: merchantType, shopName: shopName, terminalType: terminalType, terminalId: terminalId, machineRwCd: machineRwCd, merchantOrgInfo: merchantOrgInfo, isInstalled: isInstalled })
    }

    /**
     *
     * 編集画面表示
     *
     * @param data 選択された行のデータ
     */
    const showEdit = () => {
        //setMode('edit');
        setModeInfo({ mode: 'edit', merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchantName: modeInfo.merchantName, merchantType: modeInfo.merchantType, shopName: modeInfo.shopName, terminalType: modeInfo.terminalType, terminalId: modeInfo.terminalId, machineRwCd: modeInfo.machineRwCd, merchantOrgInfo: modeInfo.merchantOrgInfo, isInstalled: modeInfo.isInstalled })
    }

    /**
     *
     * 新規画面表示
     *
     */
    const showCreate = (merchantName, merchantType, shopName, terminalType, terminalId, machineRwCd, merchantOrgInfo, isInstalled) => {
        terminalActions.loadEditModel(token, null, modeInfo.merchant_id)
            .then(data => {
                setModeInfo({ mode: 'create', merchant_id: modeInfo.merchant_id, merchant_name: modeInfo.merchant_name, merchantName: merchantName, merchantType: merchantType, shopName: shopName, terminalType: terminalType, terminalId: terminalId, machineRwCd: machineRwCd, merchantOrgInfo: merchantOrgInfo, isInstalled: isInstalled })
            })
            .catch(e => {
                notificationActions.showError('詳細データを取得できませんでした。');
            });
    }

    var listClass = classes.hiddenList;
    if (modeInfo.mode == 'mlist') {
        listClass = classes.visibleList;
    }

    var content = <div></div>;
    //　加盟店の場合、端末一覧を表示
    if (modeInfo.mode == 'mlist' && userData != null && (userData.role == 4 || userData.role == 5)) {
        if (userData.role == 5) {
            // 店舗
            // userData.org_idには店舗IDを保持している
            // userData.merchant_idに加盟店IDを保持する
            setModeInfo({ mode: 'tlist', merchant_id: userData.merchant_id, merchant_name: userData.org_name, merchantName: modeInfo.merchantName, merchantType: modeInfo.merchantType, shopName: modeInfo.shopName, terminalType: modeInfo.terminalType, terminalId: modeInfo.terminalId, machineRwCd: modeInfo.machineRwCd, merchantOrgInfo: modeInfo.merchantOrgInfo, isInstalled: modeInfo.isInstalled });
        } else {
            // 加盟店
            setModeInfo({ mode: 'tlist', merchant_id: userData.org_id, merchant_name: userData.org_name, merchantName: modeInfo.merchantName, merchantType: modeInfo.merchantType, shopName: modeInfo.shopName, terminalType: modeInfo.terminalType, terminalId: modeInfo.terminalId, machineRwCd: modeInfo.machineRwCd, merchantOrgInfo: modeInfo.merchantOrgInfo, isInstalled: modeInfo.isInstalled });
        }
    }

    if (modeInfo.mode == 'tlist') {
        content = <TerminalList onCreate={showCreate} merchantId={modeInfo.merchant_id} merchantName={modeInfo.merchant_name} merchantNameSearch={modeInfo.merchantName} merchantType={modeInfo.merchantType} shopName={modeInfo.shopName} terminalType={modeInfo.terminalType} terminalId={modeInfo.terminalId} machineRwCd={modeInfo.machineRwCd} merchantOrgInfo={modeInfo.merchantOrgInfo} isInstalled={modeInfo.isInstalled} onCancel={showList} onEdit={showEdit} onDetail={showDetail} refresh={listRefresh} />
    }

    if (modeInfo.mode == 'detail') {
        content = <TerminalDetail onCancel={showTerminalList} onEdit={showEdit} />
    }
    if (modeInfo.mode == 'edit') {
        content = <TerminalEdit onCancel={showTerminalList} merchantId={modeInfo.merchant_id} merchantName={modeInfo.merchant_name} />
    }
    if (modeInfo.mode == 'create') {
        content = <TerminalEdit onCancel={showTerminalList} merchantId={modeInfo.merchant_id} merchantName={modeInfo.merchant_name} />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <MerchantList onList={showTerminalList} merchantNameSearch={modeInfo.merchantName} merchantType={modeInfo.merchantType} refresh={listRefresh} />
            </div>
        </div>
    )
}

export default withStyles(style, { withTheme: true })(Terminal);
